/**
 * Whether a test runner drives this browser: Playwright, Selenium and other WebDriver clients set
 * `navigator.webdriver`, so it holds on Checkly and in the e2e suites and not for a person.
 *
 * Gates dev-only overlays such as the router and React Query devtools. Their panels print route
 * names, search params and query state as text, which text locators then match too.
 * False where there is no `navigator` (Node, SSR).
 */
export const isAutomatedBrowser = (): boolean =>
    // Neither the shared base's worker `navigator` nor Node's has `webdriver`.
    (globalThis as { navigator?: { webdriver?: boolean } }).navigator?.webdriver === true;
